import { useEffect } from "react";
import { useMaintenanceDispatch } from "../contexts/MaintenanceContext";

export default function useGetMaintenanceTime() {
    const maintenanceDispatch = useMaintenanceDispatch();

    useEffect(() => {
        fetch(`/api/maintenance`, { credentials: 'include' })
            .then(r => r.json())
            .then(data => {
                if (!data || !data?.scheduledTime) {
                    // fallback to null if no scheduled time is returned
                    maintenanceDispatch({ type: 'setScheduledTime', payload: { scheduledTime: null } });
                    return;
                }
                maintenanceDispatch({ type: 'setScheduledTime', payload: data });
            })
            .catch(error => {
                console.error("Error fetching maintenance time:", error);
            })
    }, [])
};